import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_FEEDER_SERVICE_PRICE_DETAIL:
      return { ...action.value };
    default:
      return state;
  }
};
